import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DocumentLinkSelectorComponent } from './document-link-selector.component';
import { MatListModule } from '@angular/material/list';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [DocumentLinkSelectorComponent],
  imports: [CommonModule, MatButtonModule, MatListModule, CdkAccordionModule, MatIconModule],
  exports: [DocumentLinkSelectorComponent]
})
export class DocumentLinkSelectorModule {}
